import { FC } from 'react';

import { usePageTitleTranslation } from 'libs/navigation';

import { useOrders } from '../hooks/useOrders';
import { OrdersView } from '../views/OrdersView';

export type OrdersContainerProps = {};

export const OrdersContainer: FC<OrdersContainerProps> = () => {
  const {
    orders,
    loading,
    page,
    rowCount,
    limit,
    sort,
    brokerTimezoneOffset,
    setRowHref,
    onSortChange,
    onPaginationChange,
    filter,
    setFilter,
  } = useOrders();

  usePageTitleTranslation('order.orders.title');

  return (
    <OrdersView
      brokerTimezoneOffset={brokerTimezoneOffset}
      filter={filter}
      limit={limit}
      loading={loading}
      orders={orders}
      page={page}
      rowCount={rowCount}
      setFilter={setFilter}
      setRowHref={setRowHref}
      sort={sort}
      onPaginationChange={onPaginationChange}
      onSortChange={onSortChange}
    />
  );
};
